import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import './home.css';
import Render from './render';
import Actions from '../../actions';
import { TAPIRequestCanceller } from '../../services/api';
import { trackView } from '../../services/analytics';
import { FETCH_BANNERS } from '../../constants/actions';

class HomePage extends React.Component<any> {
  bannersReq: TAPIRequestCanceller;
  private readonly imageFileExtensionRegex = /png|jpg|jpeg?$/;
  private readonly videoFileExtensionRegex = /mp4?$/;

  private readonly subsidiaryBrandLogos = [
    {
      name: 'Casa De Montecristo',
      logo: require('../../assets/images/home-comp-logos-cdm.png'),
      url: 'https://www.casademontecristo.com/'
    },
    {
      name: 'Romeo Y Julieta',
      logo: require('../../assets/images/home-comp-logos-romeo.png'),
      url: 'https://romeoyjulietacigars.com/'
    },
    {
      name: 'H Upmann',
      logo: require('../../assets/images/home-comp-logos-hupmann.png'),
      url: 'https://www.altadisusa.com/cigars/h-upmann'
    },
    {
      name: 'JR Cigars',
      logo: require('../../assets/images/home-comp-logos-jrcigars.png'),
      url: 'https://www.jrcigars.com/'
    },
    {
      name: 'Montecristo',
      logo: require('../../assets/images/home-comp-logos-montecristo.png'),
      url: 'https://montecristo.com/'
    },
    {
      name: 'Henry Clay',
      logo: require('../../assets/images/home-comp-logos-henry.png'),
      url: 'https://www.altadisusa.com/cigars/henry-clay'
    },
    {
      name: 'Serious Cigars',
      logo: require('../../assets/images/home-comp-logos-serious-cigars.png'),
      url: 'https://www.seriouscigars.com/'
    },
    {
      name: 'Cigars.com',
      logo: require('../../assets/images/home-comp-logos-cigars-com.png'),
      url: 'https://www.cigars.com/'
    },
    {
      name: 'Chase The Ace',
      logo: require('../../assets/images/home-comp-logos-cta.png'),
      url: 'https://www.romeochasetheace.com/'
    },
    {
      name: 'Montecristo Social Club',
      logo: require('../../assets/images/home-comp-logos-msc.png'),
      url: 'https://www.montecristosocialclub.com/'
    },
  ];

  private PARAMS = {
    fields: 'title, description, button_text, button_url, banner, banner_thumb'
  };

  isVideoFile = (file) => {
    return this.videoFileExtensionRegex.test(this.fileExtension(file));
  }

  isImageFile = (file) => {
    return this.imageFileExtensionRegex.test(this.fileExtension(file));
  }

  fileExtension = (file) => {
    return file.substr(file.lastIndexOf('.') + 1);
  }

  componentDidMount() {
    trackView('/');
    this.bannersReq = Actions.get(this.props.dispatch, FETCH_BANNERS, this.PARAMS);
  }

  componentWillUnmount() {
    this.bannersReq.cancel('Banners request cancelled');
  }

  render() {
    return Render.call(this, this.props, this.state);
  }
}

const state = ({ banners: { banners } }) => ({
  banners
});

export default withRouter(connect(state)(HomePage));



// WEBPACK FOOTER //
// ./src/containers/Home/index.tsx